import { render, staticRenderFns } from "./CardDetailsForm.vue?vue&type=template&id=178e5e3c&scoped=true&"
import script from "./CardDetailsForm.vue?vue&type=script&lang=js&"
export * from "./CardDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailsForm.vue?vue&type=style&index=0&id=178e5e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178e5e3c",
  null
  
)

export default component.exports